module.exports = __webpack_public_path__ + "static/media/thumbnail.736d9e3a.jpg";